export { TermsPage, getStaticProps, getStaticPaths } from "./TermsPage";
